import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Card from '../../../../components/Card';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { toast } from 'react-toastify';
import { getApiCall } from '../../../../service/getApiCall';
import { postApiMediaCall } from '../../../../service/postApiCall';
import { fetchAndSetFlashMessage } from '../../../../service/fetchFlashMessage';
import { API_CREATE_PROMPTS , API_GET_LANGUAGES} from '../../../../service/url';
import { useNavigate } from 'react-router-dom';
import { ROUTES, USER_ROLES, FLASH_MESSAGE_ACTION_OBJECT, MODULE_ACL } from '../../../../utilities/constant';
import LottieAnimation from '../../../../components/lottie/lottie';
import Modal from "react-bootstrap/Modal";
import "../../../../assets/custom/css/custom.css"
import { getUser } from "../../../../utilities/setting";


const AddVoice = () => {
    const [file, setFile] = useState(null);
    const [category, setCategory] = useState([]);
    const [fileName, setFileName] = useState('');
    const [fileNameError, setFileNameError] = useState('');
    const [toastProps, setToastProps] = useState(null);
    const [showToastModal, setShowToastModal] = useState(false);
    const [sendCategory, setSendcategory] = useState(null);
    const [toastMessage, setToastMessage] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [languages, setLanguages] = useState([]);
    const navigate = useNavigate();
    const [selectedLanguage, setSelectedLanguage] = useState('')
    const [isUploading, setIsUploading] = useState(false);
    const [activeModule, setActiveModules] = useState([]);
    const [moduleOperations, setModuleOperations] = useState({});
    const [userRole, setUserRole] = useState(undefined);
    const [alertMessage, setAlertMessage] = useState(null);

    useEffect(() => {
        getUser().then((resp) => {
          if (resp) {
            setUserRole(resp.role);
            if (resp?.acl_settings) {
              setModuleOperations(JSON.parse(resp?.acl_settings?.module_operations))
              const modules = getKeysWithTrueValues(JSON.parse(resp?.acl_settings?.module_operations));
              setActiveModules(modules);
            }
          }
        });
        fetchAndSetFlashMessage(
            msg => msg.module_name === MODULE_ACL.VOICE_LIBRARY && msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD,
            setAlertMessage
        );
      }, []);

      function getKeysWithTrueValues(moduleOperations) {
            return Object.keys(moduleOperations).filter(key => {
                const permissions = moduleOperations[key];
                return Object.values(permissions).some(value => value === true);
        });
  }

    const showToasts = (message) => {
        setToastMessage(message);
        setShowToastModal(true);

        // Hide modal automatically after 3 seconds
        setTimeout(() => {
            setShowToastModal(false);
        }, 3000);
    };

    // useEffect(() => {
    //         if (toastProps) {
    //             setShowToast(true);
    //         }
    
    //     }, [toastProps]);

    const handleFileUpload = (e) => {
        const uploadedFile = e.target.files[0];
        setFile(uploadedFile);
    };


    const uploadFile = async (file, category, fileName) => {
        const formData = new FormData();
        formData.append('file', file);    
        formData.append('prompt_category', category); 
        formData.append('prompt_name', fileName);
        formData.append('language', selectedLanguage);

        try {
            postApiMediaCall(API_CREATE_PROMPTS, formData)
                .then(resp => {
                    onPromptsSuccess(resp);
                })
                .catch(err => {
                    onPromptsError(err);
                })
                .finally(() => {
                    setIsUploading(false);
                })
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };

    function onPromptsSuccess(resp) {
        showToasts('Voice File Uploaded Successfully, Please wait for Admin Approval')
        setTimeout(() => {
            navigate(`/${ROUTES.VOICE_LIBRARY.VIEW_VOICE_FILES}`);
        }, 1500);
    }

    function onPromptsError(err) {
        toast.error(JSON.stringify(err));
    }
    
    const validateFileName = (name) => {
        // Allow only alphanumeric characters, underscore, and hyphen
        // No spaces or special characters
        const validPattern = /^[a-zA-Z0-9_-]+$/;
        
        if (name.trim() === '') {
            setFileNameError('File name is required');
            setIsUploading(true);
            return false;
        }
        
        if (name.includes(' ')) {
            setFileNameError('File name cannot contain spaces');
            setIsUploading(true);
            return false;
        }
        
        if (!validPattern.test(name)) {
            setFileNameError('File name can only contain letters, numbers, underscore (_), and hyphen (-)');
            setIsUploading(true);
            return false;
        }
        
        setFileNameError('');
        setIsUploading(false);
        return true;
    };

    const handleFileNameChange = (e) => {
        const value = e.target.value;
        setFileName(value);
        // Validate in real-time
        if (value.trim() !== '') {
            validateFileName(value);
        } else {
            setFileNameError('');
        }
    };

    const handleUpload = async () => {
        if (!file || !sendCategory || !fileName.trim() || !selectedLanguage.trim()) {
            toast.error("Please fill all fields!");
            setShowToast(true);
            // setIsUploading(true);
            return;
        }
        
        // Validate file name before upload
        if (!validateFileName(fileName)) {
            toast.error("Please fix the file name errors before uploading");
            return;
        }
        
        setIsUploading(true);
        uploadFile(file, sendCategory, fileName);
    };
    
    const fetchCategories = () =>{
        getApiCall('/v2/voice-category').then((response)=>
        {
            if(response)
            {
                setCategory(response.categories)
            }
        })
    }

    const fetchLanguages = () =>{
        getApiCall(API_GET_LANGUAGES).then((response)=>

        {
            if(response)
            {
                const transformed = response.map(item =>
                    Object.entries(item.language).map(([key, value]) => ({
                      label: value,
                      value: key
                    }))
                  );

                setLanguages(transformed[0])
            }
        })
    }

    useEffect(()=> {
       fetchCategories();
       fetchLanguages();
    },
    [])


    return (
        <>
        {alertMessage && <marquee className="fade alert alert-success show" style={{marginTop : '5px'}}>{alertMessage}</marquee>}
        <div>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-end align-items-center">
                            <h4 className="card-title">Upload Voice File</h4>   
                            {(userRole === USER_ROLES.CALL_CENTRE_ADMIN && activeModule?.includes('TTS')) &&
                                <Button
                                    label="Add TTS"
                                    onClick={() => navigate(`/${ROUTES.TTS.CREATE}`)}
                                    className="p-button-primary mb-3"
                                    type="button"
                                    disabled={!(userRole === USER_ROLES.CALL_CENTRE_ADMIN && activeModule?.includes('TTS'))}
                                />
                            }
                        </Card.Header>
                        <Card.Body>
                            <form>
                                <Row className="mb-3">
                                    <Col md="6">
                                        <label htmlFor="uploadFile" className="form-label">
                                            Upload WAV or MP3 File
                                        </label>
                                        <input
                                            type="file"
                                            id="uploadFile"
                                            className="form-control"
                                            accept=".wav, .mp3"
                                            onChange={handleFileUpload}
                                        />
                                    </Col>
                                    <Col md="6">
                                        <label htmlFor="fileName" className="form-label">
                                            File Name <span style={{ color: "red", margin: "0 4px" }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="fileName"
                                            value={fileName}
                                            onChange={handleFileNameChange}
                                            onKeyDown={(e) => {
                                                if (e.key === ' ') {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onBlur={() => validateFileName(fileName)}
                                            className="form-control"
                                            placeholder={fileNameError ? "File name cannot contain spaces or special characters" : "File Name (letters, numbers, _, - only)"}
                                            style={{
                                                borderColor: fileNameError ? '#dc3545' : undefined,
                                                backgroundColor: fileNameError ? '#fff5f5' : undefined
                                            }}
                                        />
                                        {fileNameError && (
                                            <div className="text-danger" style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                                {fileNameError}
                                            </div>
                                        )}
                                        {/* <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                            Allowed: Letters (a-z, A-Z), Numbers (0-9), Underscore (_), Hyphen (-). No spaces or special characters.
                                        </small> */}
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md="6">
                                        <label htmlFor="category" className="form-label">
                                            Select Category
                                        </label>
                                        <Dropdown
                                            style={{ height: "50%", alignItems: "center" }}
                                            id="category"
                                            value={sendCategory}
                                            options={category}
                                            onChange={(e) => setSendcategory(e.value)}
                                            placeholder="Select Category"
                                            className="form-control p-column-filter my-dropdown"
                                            panelClassName="my-dropdown-panel"
                                        />
                                    </Col>
                                    <Col md="6">
                                        <label htmlFor="language" className="form-label">
                                            Select Language
                                        </label>
                                        <Dropdown
                                            style={{ height: "50%", alignItems: "center" }}
                                            id="language"
                                            value={selectedLanguage}
                                            options={languages}
                                            panelClassName="my-dropdown-panel"
                                            onChange={(e) => setSelectedLanguage(e.value)}
                                            placeholder="Select Language"
                                            className="form-control p-column-filter my-dropdown"
                                        />
                                    </Col>
                                </Row>
                                <Button
                                    label="Upload File"
                                    onClick={handleUpload}
                                    className="p-button-danger mt-3"
                                    type="button"
                                    disabled={isUploading}
                                />
                            </form>
                        </Card.Body>

                    </Card>
                </Col>
            </Row>
        </div>

      {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

       {/* LOTTIE MODEL FOR TOAST */}
       <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
                <Modal.Body className="text-center">
                    <h5>{toastMessage}</h5>
                    <LottieAnimation />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddVoice;
